import { IForgotPasswordForm } from '../pages/forgotPasswordPage/forgotPasswordInterface';
import { post } from './apiService';

export const forgotPassword = async (data: IForgotPasswordForm) => {
  return await post('/auth/forgot-password', data);
};
